<template>
  <div>
    <div v-show="$store.state.operate!='添加'&&$store.state.operate!='编辑'&&$store.state.operate!='详情'&&$store.state.operate!='复制'" class="page-list">
	<el-dialog v-if="dialogVisible"
	   title="分配座位"
	   :visible.sync="dialogVisible"
								:before-close="dialogVisibleClick"
	   width="60%"
	>
	 
	  <el-form   class="demo-form-inline">
	  	<el-form-item    label='规格'>
	  	<el-radio-group @change="skuIdChange" v-model="skuId">
	  		<el-radio v-for="(item,index) in skuList" :label="item.id">{{item.param}}</el-radio>
	  	</el-radio-group>
		<div v-if="skuId" class="input-desc">
			绿色表示位置空闲,红色表示已占位,黄色表示位置锁定
		</div>
	  	 </el-form-item>
	  		<el-form-item    label=''>
				<!-- <el-row> -->
				  <div  v-for="item in addressList" class="w-20 " style="display: inline-block;">
					  <el-card     class="box-card mr-2">
					    <div  class="text item">
							<i   v-if="item.name" class="el-icon-unlock text-red f30"></i>
							<i @click.stop="lockClick(item)"  v-if="!item.name&&!item.isLock" class="el-icon-unlock text-success f30"></i>
							<i @click.stop="lockClick(item)" v-if="!item.name&&item.isLock"  class="el-icon-unlock text-warning f30"></i>
					   <span @click="setsClick(item)"> {{item.title}}</span>  
					    </div>
					  </el-card>
				  </div>
				<!-- </el-row> -->
	  		
	  		 </el-form-item>
	  	
	  	  
	  	</el-form>
	   <span slot="footer" class="dialog-footer">
		 <el-button @click="dialogVisibleClick">取 消</el-button>
		 <el-button type="primary" @click="modalClose">确 定</el-button>
	   </span>
	 </el-dialog> 
	 <el-dialog v-if="dialogVisibles"
	    title="配置灯位"
	    :visible.sync="dialogVisibles"
	 							:before-close="dialogVisiblesClick"
	    width="75%"
		
	 >
	  
	   <el-form v-if="dialogVisiblesl==0"  :inline="true" label-width="80px" class="demo-form-inline">
	   		<el-form-item   v-for="(item,index) in cengList"  :label='"第"+item.no+"层"'>
	 			  <el-input v-model="item.length" type="number" style="width: 120px;" placeholder="请填写灯位" >
	 			  </el-input>
	   		 </el-form-item>
	   	</el-form>
		<el-form v-if="dialogVisiblesl==1"    label-width="80px" class="demo-form-inline">
				<el-form-item   v-for="(item,index) in cengList"  :label='"第"+item.no+"层"'>
					<template v-for="(items,index) in item.list">
						<div class="mr-1 mb-1 el-input el-input--small  el-input-group el-input-group--append" style="width: 160px;">
							<!----><input type="number" @click.stop="setsClick(items)"    readonly="readonly" autocomplete="off" :placeholder="items.nos+'号灯位'" class="el-input__inner"><!----><!---->
							<div v-if="items.id" class="el-input-group__append " style="padding: 0 10px;">
								<i  @click.stop="lockClick(items)" v-if="!items.name&&!items.isLock"  class="el-icon-unlock text-success"></i>
								<i  @click.stop="lockClick(items)" v-if="items.isLock"  class="el-icon-unlock text-warning"></i>
								<i   v-if="items.name"  class="el-icon-unlock text-red"></i>
								</div><!----></div>
						  </template>
				 </el-form-item>
			</el-form>
	    <span slot="footer" class="dialog-footer">
	 	 <el-button @click="dialogVisiblesClick">取 消</el-button>
	 	 <el-button type="primary" @click="modalsClose">确 定</el-button>
	    </span>
	  </el-dialog> 
	 <el-drawer 
	   title="挑选位置"
	    
	   :visible.sync="drawer"
	   :before-close="handleClose">
	   <!-- <el-row class="mx-2">
	     <el-col   v-for="item in newAddressList" :span="24">
	   	  <el-card    class="box-card mr-1 mb-1">
	   	    <div  @click="updatesClick(item)" class="text item">
	   			<i   v-if="item.isLock" class="el-icon-unlock text-warning f30"></i>
	   	     {{item.title}}
	   	    </div>
	   	  </el-card>
	     </el-col>
	   </el-row> -->
	   <el-form     label-width="80px" class="demo-form-inline">
	   		<el-form-item   v-for="(item,index) in newAddressList"  :label='"第"+item.no+"层"'>
	   			<template v-for="(items,index) in item.list">
	   				<div class="mr-1 mb-1 el-input el-input--small  el-input-group el-input-group--append" style="width: 160px;">
	   					<!----><input type="number" @click.stop="updatesClick(items)"    readonly="readonly" autocomplete="off" :placeholder="items.nos+'号灯位'" class="el-input__inner"><!----><!---->
	   				</div>
	   				  </template>
	   		 </el-form-item>
	   	</el-form>
	 </el-drawer>
	<com-page-title  @callbackOperate="callbackOperate" ></com-page-title>
	  <!-- 搜索栏 -->
	<el-form :inline="true"  class="demo-form-inline">
		<el-form-item v-if="form.status==20" label="">
			<el-select  v-model="form.tag" clearable @change="callbackIndex(1)" placeholder="商品标签">
				 <el-option
				   v-for="item in tagList"
				   :key="item"
				   :label="item"
				   :value="item">
				 </el-option>
			 
			  </el-select>
		</el-form-item>
		
		
		<el-form-item label="">
				  <el-input  clearable  @clear="callbackIndex(1)" v-model="form.title"  @change="callbackIndex(1)"
		placeholder="标题"></el-input>
				</el-form-item>
			
		<el-form-item  label="">
		    <el-date-picker prefix-icon="none"
		         v-model="form.dateRange"
		         type="datetimerange"
				 value-format='yyyy-MM-dd HH:mm:ss' :editable="false"
				  start-placeholder="开始时间"
				       end-placeholder="结束时间"
		         range-separator=""
				   @change="callbackIndex(1)">
		       </el-date-picker>
		  </el-form-item>
		   <el-form-item label="">
		 <el-button @click="callbackIndex(1)" type="primary">搜索</el-button>
		  </el-form-item>
		</el-form>
		
      <el-table
        :data="pageData"
        highlight-current-row
        style="width: 100%;"
		:height="$store.state.height-328"
		ref="multipleTable"
		@select-all="selectChange"
		@select="selectChange"
		@sort-change="sortChange">
	   <template slot="empty"><el-empty description="暂时没有数据"></el-empty> </template>
		      <el-table-column type="selection"></el-table-column>
		   <com-page-index></com-page-index>
		 
		 <el-table-column prop='title' label='商品名称'  ></el-table-column>
		 <el-table-column prop='tag' label='商品标签' v-if="form.status==20" ></el-table-column>
		  <com-page-imgurl column='imgurl' title='图片' ></com-page-imgurl> 
		 <el-table-column sortable="custom"  prop='createTime' label='创建时间' ></el-table-column>
		 
		
			<com-page-orders></com-page-orders>
			<com-page-isshow></com-page-isshow>
			<el-table-column  v-if="form.status==10"  width="140"  prop="orders" label="配置">
			  <template slot-scope="scope">
			 <div @click="setdengClick(scope.row)" class="text-primary">  配置灯位</div>
			 	</template>
			</el-table-column>
	<!-- 	<el-table-column  v-if="form.status==10"  width="140"  prop="orders" label="座位">
		  <template slot-scope="scope">
		 <div @click="setClick(scope.row.id)" class="text-primary">  点击分配</div>
		 	</template>
		</el-table-column> -->
		 <!-- 操作按钮 -->
		<com-page-operate :columnList="columnList"  :pageData="pageData" @callbackOperate="callbackOperate"></com-page-operate>
      </el-table>
	    <!-- 分页页面 -->
	  <com-page-number @callbackOperate="callbackOperate" @callbackIndex="callbackIndex" ></com-page-number>
    </div>
	<!-- 表单页面 -->
    <div v-if="$store.state.operate=='添加'||$store.state.operate=='编辑'||$store.state.operate=='详情'||$store.state.operate=='复制'"> 
      <edit  @callbackPage="callbackPage"   :id="id"></edit>
    </div>
	<!-- 返回按钮 -->
	<com-page-return @callbackPage="callbackPage" v-if="$store.state.operate=='添加'||$store.state.operate=='编辑'||$store.state.operate=='详情'||$store.state.operate=='复制'"></com-page-return>
	<!-- 导入页面 -->
	<com-page-import @callbackImport="callbackImport"  v-if="$store.state.operate=='导入'"></com-page-import>
	<!-- 导出页面 -->
	<com-page-export  v-if="$store.state.operate=='导出'"></com-page-export>
 <!-- 账号配置列 -->
	<com-page-columns  @callbackColumns="callbackColumns"  v-if="$store.state.operate=='配置列'"></com-page-columns>
 </div>
</template>
<script>
import edit from "@/components/edit/com-edit-productSpu"; 
export default {
  components: {edit },
  data() {
    return {
		cengList:[],
		drawer:false,
		newAddressList:[],
		newid:'',
		addressList:[],
		skuId:'',
		skuList:[],
		obj:'',
		dialogVisible:false,
		dialogVisibles:false,
		dialogVisiblesl:0,
		spuId:'',
	columnList:[],//权限列
		pageData:[],//页面数据
		recommendList:['热门推荐','最近上新','首页推荐'],
		id:'',//表单主键id
		tagList:[
			'生活文创','加持圣品','祈福献供'
		],
		form:{//搜索表单
			dateRange: this.$dateRangeCurrent,//时间
			groups:'',
			title:'',
			classExt:'',
			authorize:'',
			create:'',
			multiple:'',
			status:''
		},
    };
  },
   watch: {
      $route(to,from){ //路由监听
	   this.form.groups=this.$route.query.groups||'';
	   this.form.status=this.$route.query.status||'';
	    this.form.authorize=this.$route.query.authorize||'';
		 this.form.create=this.$route.query.create||'';
	   this.form.dateRange=this.$dateRangeCurrent;
	      this.form.title='';
		     this.form.classExt='';
	    this.callbackIndex(1)
        }
     },
  methods: {
	  setdengClick(e){
		  let array=[];
		  this.spuId=e.id;
		   this.dialogVisiblesl=0;
		  if(e.model){
			  this.$axios.get(`/api/ProductSpu/GetProductSpuAppendAddress?id=`+e.id,null).then(e => {
			  						  this.cengList=e;
			  						  this.dialogVisibles=true;
									  this.dialogVisiblesl=1;
			  			});
						return;
		  }
		  this.$axios.get(`/api/ProductSpu/GetProductSpuSku?id=`+e.id,null).then(e => {
			  let no=0;
		  			for (let i = 0; i < e.length; i++) {
						for (let j = 0; j < e[i].limit; j++) {
							no++;
							 array.push({titles:e[i].param, no:no,list:[],length:'',skuId:e[i].id,spuId:e[i].spuId})
						}
		  						  }
		  						  this.cengList=array;
		  						  this.dialogVisibles=true;
		  			});
		
	  },
	  updatesClick(e){
		  this.$axios.get(`/api/Orders/GetOrdersAddress?id=`+e.id+'&id2='+e.newid,null).then(e => {
			   this.dialogVisibles=false;
					 this.drawer=false;
		  			});
	  },
	  setsClick(e){
		  if(!e.isLock)return
		  this.newid=e.id;
		  this.$axios.get(`/api/ProductSpu/GetProductSpuAppendAddressSku?skuId=`+e.skuId+'&id='+e.id,null).then(e => {
			  this.newAddressList=e;
			  this.drawer=true;
		  			});
	  },
	  handleClose(done){
		   done();
	  },
	  lockClick(item){
		  this.$axios.get(`/api/ProductSpu/PostOrderAddress?id=`+item.id,null).then(e => {
			  this.$message.success('提交成功同步到服务器');
		  		item.isLock=!item.isLock;
		  			});
	  },
	  skuIdChange(id){
		  this.skuId=id;
		  this.$axios.get(`/api/ProductSpu/GetOrderAddress?id=`+id,null).then(e => {
		  			this.addressList=e;
		  			});
	  },
	  setClick(id){
		  this.skuId='';
		  this.addressList=[];
		  this.$axios.get(`/api/ProductSpu/GetProductSpu?id=`+id,null).then(e => {
			this.skuList=e.skuList;
		   this.dialogVisible=true;
		  			});
	  },
	  modalsClose(){
		 
		  if(this.dialogVisiblesl){
			   var list=[];
			 for (let i = 0; i < this.cengList.length; i++) {
			 			 for (let j = 0; j < this.cengList[i].list.length; j++) {
			 				list.push(this.cengList[i].list[j]);
			 			 }
			 }
			  this.$axios.post(`/api/ProductSpu/PostProductSpuAppendAddress`,{list:list,spuId:this.spuId}).then(e => {
			  		  this.$message.success('提交成功同步到服务器');
			   this.dialogVisibles=false;
			     this.callbackIndex(1);
			  			});
		  }
		  for (let i = 0; i < this.cengList.length; i++) {
		  	if(!this.cengList[i].length){
		  				  		 this.$message.error('请填写第'+(i+1)+'层等位数');return
		  	}
			var array=[];
			 for (let j = 0; j < this.cengList[i].length; j++) {
				array.push({nos:j+1,no:this.cengList[i].no,length:this.cengList[i].length,skuId:this.cengList[i].skuId,spuId:this.cengList[i].spuId,name:'',isLock:false})
			 }
			  this.cengList[i].list=array;
		  }
		  this.dialogVisiblesl=1;
	  		 //  this.dialogVisibles=false;
	  },
	  modalClose(){
		  var data=this.$pageParams(this.form,0)
		  this.$axios.get(`/api/ProductSpu/GetProductSpuMultiple`,data).then(e => {
			  this.callbackIndex(1);
		   this.$message.success('提交成功同步到服务器');
		   this.dialogVisible=false;
		   this.multiple='';
			});
	  },
	  dialogVisibleClick(){
		   this.dialogVisible=false;
		  this.multiple='';
	  },
	  dialogVisiblesClick(){
	  		   this.dialogVisibles=false;
	  },
	  multiple(e){
		  this.$axios.post(`/api/ProductSpu/PostProductSpuMultiple` ,e).then(e => {
		  			 this.$message.success('提交成功同步到服务器');
		    });
	  },
	
   callbackImport(){//导入回调
		   this.callbackIndex(1)
	  },
	   selectChange(selection,row){//选择
	  this.$store.commit("saveSelect", selection);
	  },
	  sortChange(column){//排序回调
		var list= this.$store.state.list;
		list.pageOrder=column.order == 'descending'?'desc':'asc';
		list.pageSort=column.prop;
		this.$store.commit("saveList", list);
		 this.callbackIndex(1)
	},
	  callbackOperate(e){//操作按钮事件
		  if(e.operate=='添加')
			  this.id="";
		   if(e.operate=='复制'||e.operate=='编辑'||e.operate=='详情')
			  this.id=(e.data.id||'').toString();
			  if(e.operate=='一键处理'){
			  			  this.dialogVisible=true;
			  }
		if(e.operate=='删除'){
		var id=this.$store.state.select.map(item=>item.id).join(',');
		 localStorage.setItem('SELECTIDS',id)
				this.$axios.post(`/api/ProductSpu/PostProductSpuDeleteWhere` ,'').then(e => {
					 this.$message.success('删除成功到同步服务器');
							this.callbackIndex(this.pageIndex);
				  }); 
		}
	  },
	  callbackPage(e){//表单返回事件
		  if(e.statusText=='添加'||e.statusText=='编辑'){
		    this.$store.commit("saveOperate", "");
			   this.$message.success('提交成功同步到服务器');
			this.callbackIndex(1);
		  }
	  },
    callbackIndex(i) {//获取分页数据
       var data=this.$pageParams(this.form,i)
      this.$axios.get(`/api/ProductSpu/GetProductSpuPage`,data).then(e => {
		 this.$store.commit("saveList", e);
			this.pageData=e.pageData;
        });
    }
  },
  mounted() {//页面加载事件
   this.form.groups=this.$route.query.groups||'';
   this.form.status=this.$route.query.status||'';
    this.form.authorize=this.$route.query.authorize||'';
	 this.form.create=this.$route.query.create||'';
     this.$store.commit("saveList", {});
   this.callbackIndex(1)  
  }
  
};
</script>
<style>
</style>

